import { useState, useContext } from 'react';
import GlobalStateContext from '../../context/GlobalStateContext';
import Loader from '../reusable/Loader';
import PageHeader from '../reusable/PageHeader';
import Panel from '../reusable/Panel';
import SelectDropdown from '../reusable/SelectDropdown';
import DistrictSelectionIllustration from '../assets/district-selection-illustration.png';

import './DistrictSelectionPage.css';

const DistrictSelectionPage = () => {
  const { allEoas, completeDistrictSelection } = useContext(GlobalStateContext);
  const [selectedEoaId, setSelectedEoaId] = useState('');
  const [isSelecting, setIsSelecting] = useState(false);

  if (allEoas.isPending) {
    return <Loader fullScreen={true} />;
  }

  if (allEoas.error || !allEoas.data?.length) {
    return <p className="center-text">Unable to load available districts.</p>;
  }

  const districtItems = allEoas.data.map((eoa) => ({
    label: eoa.district.name,
    value: eoa.id,
  }));

  const handleDistrictChange = async (event: { target: { value: string } }) => {
    const eoaId = event.target.value;
    if (!eoaId || isSelecting) return;

    setSelectedEoaId(eoaId);
    setIsSelecting(true);
    await completeDistrictSelection(eoaId);
    // DistrictSelectionGate unmounts this component once requiresDistrictSelection
    // becomes false, so no state cleanup needed here.
  };

  return (
    <div className="district-selection-page" data-testid="district-selection-page">
      <PageHeader title="Dashboard" />
      <div className="main-content district-selection-main">
        <Panel className="district-selection-panel">
          <div className="district-selection-panel-content">
            <div className="district-selection-form">
              <h2 className="district-selection-title">Please choose the EOAA you would like to access:</h2>
              <SelectDropdown
                label="District"
                selectedValue={selectedEoaId}
                handleChange={handleDistrictChange}
                items={districtItems}
                formControlVariant="standard"
                fullWidth={false}
                isClearable={false}
                containerClasses={['district-selection-dropdown']}
                selectSxProps={{ minWidth: '220px' }}
              />
            </div>
            <img
              src={DistrictSelectionIllustration}
              alt=""
              className="district-selection-illustration"
              aria-hidden="true"
            />
          </div>
        </Panel>
      </div>
    </div>
  );
};

export default DistrictSelectionPage;
